
/**
 * Weighted Credit Calculator
 * Credits = (InputTokens * Weight) + (OutputTokens * Weight) + (ToolCalls * FixedFee) + ComplexityBonus
 */
export const calculateTurnCredits = (usage: { prompt_tokens: number, completion_tokens: number }, toolName?: string, model?: string, systemPromptTokens: number = 0): number => {
    const W_INPUT = 0.0002; 
    const W_OUTPUT = 0.001;  
    
    const toolCosts: Record<string, number> = {
        'send_email': 3,
        'list_emails': 1,
        'list_messages': 1,
        'list_threads': 1,
        'create_calendar_event': 1,
        'search_sheet': 1,
        'get_spreadsheet_info': 1,
        'read_sheet_values': 1,
        'draft_doc': 2,
        'create_spreadsheet': 2,
    };

    // Helper to find tool costs with fuzzy matching for MCP prefixes
    const findToolCost = (name: string): number | undefined => {
        if (toolCosts[name]) return toolCosts[name];
        // Check if any key is PART of the tool name (e.g. "Gmail-send_email" contains "send_email")
        const match = Object.keys(toolCosts).find(key => name.toLowerCase().includes(key.toLowerCase()));
        return match ? toolCosts[match] : undefined;
    };

    const billableInputTokens = Math.max(0, usage.prompt_tokens - systemPromptTokens);
    let tokenCost = (billableInputTokens * W_INPUT) + (usage.completion_tokens * W_OUTPUT);
    
    // Safety Cap to prevent blowouts from extremely large sessions
    tokenCost = Math.min(tokenCost, 10);

    const matchedToolCost = toolName ? findToolCost(toolName) : undefined;
    const complexityBonus = (model?.includes('70b') || model?.includes('120b') || model?.includes('compound')) ? 1 : 0;

    // Simple Task Priority: 
    // If a tool is being executed with a fixed cost, we use ONLY that cost to keep it predictable.
    if (toolName && matchedToolCost !== undefined) {
        return matchedToolCost;
    }

    // Complex reasoning turn or non-fixed tool
    const finalCredits = tokenCost + (toolName ? 1 : 0) + complexityBonus;
    return Math.max(1, Math.ceil(finalCredits));
};
